// contractService.js

import { fetchFromWebApi } from "../utils/fetchFromWebApi";

/**
 * Function to update contract version details.
 * @param {string} id - ID of the contract version to update.
 * @param {Object} updatedData - Updated contract version data.
 * @returns {Promise} Promise that resolves to the updated contract version data.
 */
export const UpdateContractVersion = async (id, updatedData) => {
  console.log("UpdateContractVersion :", updatedData);
  try {
    const response = await fetchFromWebApi(
      `HHContract/UpdateVersionContract`,
      {
        method: "PUT",
        body: JSON.stringify(updatedData),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    console.log("Update Successfully");
    //return await response.json();
  } catch (error) {
    console.error("Error updating contract version:", error);
    throw error;
  }
};

/**
 * Function to update the IsActive status of a contract version.
 * @param {string} id - ID of the contract version to update.
 * @returns {Promise} Promise that resolves when the update is successful.
 */
export const UpdateContractActive = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/ActiveContract?id=${id}`,
      {
        method: "PUT",
        // body: JSON.stringify({ IsActive: isActive }),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    console.log(`Updated IsActive status to `);
    // Optionally return await response.json();
  } catch (error) {
    console.error("Error updating IsActive status:", error);
    throw error;
  }
};

/**
 * Function to update the IsActive status of a contract version.
 * @param {string} id - ID of the contract version to update.
 * @returns {Promise} Promise that resolves when the update is successful.
 */
export const CopyHHContract = async (id, metaData) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/CopyContract?id=${id}`,
      {
        method: "POST",
        body: JSON.stringify({
          id: id,
          metaData: metaData
        }),
      }
    );
    console.log(response);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    console.log(`Updated IsActive status to `);
    // Optionally return await response.json();
  } catch (error) {
    console.error("Error updating IsActive status:", error);
    throw error;
  }
};

export const FetchData = async (clientId, hhDocumentId) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/GetHHContractsListByClientId?clientId=${clientId}&hhDocumentId=${hhDocumentId}`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchFormFillData = async (id) => {
  try {
    const res = await fetchFromWebApi(
      `HHContract/GeneratePdf?id=${id}`,
      {
        method: "GET",
      }
    );
    if (res?.ok) {
      const json = await res.json();
      console.log("Form elements fetched successfully:", json.MetaData);
      return json.MetaData;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchContractData = async (id) => {
  try {
    const res = await fetchFromWebApi(
      `HHContract/GenerateUnsignedPdf?id=${id}`,
      {
        method: "GET",
      }
    );
    if (res?.ok) {
      const json = await res.json();
      console.log("Form elements fetched successfully:", json.MetaData);
      return json.MetaData;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const FetchTemplateLibraryData = async () => {
  try {
    const response = await fetchFromWebApi(
      `HHTemplateLibrary/GetHHTemplateLibrary`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const CopyHHTemplateLibrary = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHTemplateLibrary/CopyHHTemplateLibrary?id=${id}`,
      {
        method: "PUT"
        // body: JSON.stringify({ IsActive: isActive }),
      }
    );
    console.log(response);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error updating IsActive status:", error);
    throw error;
  }
};

export const DeleteHHTemplateLibrary = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHTemplateLibrary/Delete?id=${id}`,
      {
        method: "DELETE",
        // body: JSON.stringify({ IsActive: isActive }),
      }
    );
    console.log(response);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error updating IsActive status:", error);
    throw error;
  }
};

export const fetchTemplateLibraryDataById = async (id) => {
  try {
    const res = await fetchFromWebApi(
      `HHTemplateLibrary/GetHHTemplateLibraryById?id=${id}`,
      {
        method: "GET"
      }
    );
    if (res?.ok) {
      const json = await res.json();
      console.log("Form elements fetched successfully:", json.MetaData);
      return json.MetaData;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const FetchAlContractDocumentData = async (clientId, hhDocumentId) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/GetAllContractDocuments?clientId=${clientId}&hhDocumentId=${hhDocumentId}`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    console.log(result);
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const fetchHHContractById = async (contractVersionId) => {
  try {
    const res = await fetchFromWebApi(
      `HHContract/GetHHContractsById?id=${contractVersionId}`,
      {
        method: "GET"
      }
    );

    if (res.status === 401) {
      // Handle the 401 Unauthorized error here
      console.error("Authentication failed. The token is invalid or expired.");

      // Example: Redirect the user to the login page
      window.location.href = '/login';
    } else if (res?.ok) {
      const json = await res.json();
      return json;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const fetchAdminHHContractById = async (contractVersionId) => {
  try {
    const res = await fetchFromWebApi(
      `HHContract/GetAdminHHContractsById?id=${contractVersionId}`,
      {
        method: "GET"
      }
    );

    if (res?.ok) {
      const json = await res.json();
      return json;
    } else {
      console.error("Failed to fetch form elements:", await res.text());
    }
  } catch (error) {
    console.error("Error while fetching form elements:", error);
  }
};

export const FetchGetContractDocumentListById = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/GetContractDocumentListById?id=${id}`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const FetchCommentByContractVersionId = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/GetCommentByContractVersionId?contractVersionId=${id}`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    console.log(result);
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const FetchAdditionalFilesByContractVersionId = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/GetAdditionalDocumentByContractVersionId?contractVersionId=${id}`,
      {
        method: "GET"
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const result = await response.json();
    console.log(result);
    return result;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const DeleteComment = async (id) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/DeleteComment?id=${id}`,
      {
        method: "DELETE"

        // body: JSON.stringify({ IsActive: isActive }),
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response;
    console.log(`Updated IsActive status to `);
    // Optionally return await response.json();
  } catch (error) {
    console.error("Error updating IsActive status:", error);
    throw error;
  }
};
export const ReplyComment = async (commentReplyRequest) => {
  try {
    const response = await fetchFromWebApi(
      `HHContract/ReplyComment`,
      {
        method: "POST",
        body: JSON.stringify({
          commentReply: commentReplyRequest.commentReply,
          parentCommentId: commentReplyRequest.parentCommentId,
          userId: commentReplyRequest.userId,
        }),
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    // const result = await response.json();
    // console.log(result);
    return response;
  } catch (err) {
    throw new Error(err.message);
  }
};
